export default ['ru', 'tr'];
